import { formatCurrency } from './api';
import { formatDateShort } from './dateFormat';

// The "missing notes" panel of LinkDeliveryNotesModal renders through these
// helpers, and missingNotesComment turns the same data into plain text for a
// comment to the customer (it is emailed too, so no markup). One source for
// the wording, so what the customer reads is what the admin saw.

export const missingKindLabel = (m) => (m.ref_kind === 'return' ? 'תעודת החזרה' : 'תעודת משלוח');

// A missing return reduces what the invoice bills for, so it reads with a
// minus — same convention as the notes table and as missing_total.
export const missingAmountText = (m) => (m.amount == null
  ? '—'
  : `${m.ref_kind === 'return' ? '−' : ''}${formatCurrency(m.amount)}`);

// Some invoices list their notes as headings over product groups and print no
// per-note amount (פפירוס). "סה״כ חסר: ₪0.00" there would read as "nothing is
// missing" — the opposite of the truth — so say plainly that it is unknown.
export function missingTotalText(coverage) {
  const count = coverage.missing.length;
  if (coverage.missing_without_amount === count) {
    return 'החשבונית אינה מפרטת סכום לכל תעודה, ולכן לא ניתן לחשב את הסכום החסר';
  }
  let text = `סה״כ חסר: ${formatCurrency(coverage.missing_total)}`;
  if (coverage.missing_without_amount > 0) {
    text += ` · ל-${coverage.missing_without_amount} תעודות אין סכום מודפס ולכן הן אינן כלולות`;
  }
  return text;
}

// '' when nothing is missing. Worded as a request to complete the documents
// (Ora's wording), not as "these never arrived": a note linked to another
// month's מרכזת, or a supplier whose מרכזת prints a different number series,
// also lands in `missing` — the text must not claim more than the match knows.
export const MISSING_LIST_HEADER = 'על מנת שנוכל להמשיך בהתאמת המרכזת לתעודות המשלוח, נודה להשלמת המסמכים הבאים:';

// Has this list already gone to the customer? Recognised by its opening line,
// so the save's "send" checkbox is pre-ticked only the first time.
export const missingListAlreadySent = (comments) =>
  (comments || []).some(c => String(c.comment || '').startsWith(MISSING_LIST_HEADER));

// What can be asked of the customer: not a reference we hold in another form (a
// `blocker` from the server), which only the admin can sort out. The total follows,
// signed as the server signs it. A return reduces it.
export function askableMissing(coverage) {
  const missing = (coverage?.missing || []).filter(m => !m.blocker);
  const signed = missing.reduce((s, m) => s + (m.amount == null ? 0 : (m.ref_kind === 'return' ? -Math.abs(m.amount) : Math.abs(m.amount))), 0);
  return {
    ...coverage,
    missing,
    missing_total: Math.round(signed * 100) / 100,
    missing_without_amount: missing.filter(m => m.amount == null).length,
  };
}

export function missingNotesComment(fullCoverage) {
  const coverage = askableMissing(fullCoverage);
  const missing = coverage.missing;
  if (!missing.length) return '';

  const lines = [MISSING_LIST_HEADER];
  for (const m of missing) {
    lines.push([
      `• ${m.ref_num}`,
      formatDateShort(m.ref_date) || '—',
      missingKindLabel(m),
      missingAmountText(m),
    ].join(' · '));
  }
  lines.push(missingTotalText(coverage));
  return lines.join('\n');
}
